<div class="contenedor {{ responsiveService.claseCSS$ | async }}">
  @for (categoria of NAVEGACION; track categoria) {
    @if (mostrarCategoria().get(categoria.nombre)) {
      <div class="categoria">
        <h2>{{ categoria.nombre }}</h2>
        <div class="paginas">
          @for (pagina of categoria.paginas; track pagina) {
            <a *autorizacion="pagina.autorizacion" class="pagina" [routerLink]="pagina.url">
              <div class="icono {{ pagina.imagen }}">
                <img class="imagen" src="assets/icons/{{ pagina.imagen }}.png" />
                <img class="animacion" src="assets/icons/{{ pagina.imagen }}.gif" />
              </div>
              <p>{{ pagina.nombre }}</p>
            </a>
          }
        </div>
      </div>
    }
  }
  <!-- CASO ESPECIAL: Evedisa Eje Cafetero (Comfenalco) -->
  @if ((usuario$ | async)?.id == 111) {
    <div class="categoria">
      <div class="paginas">
        <a class="pagina" [routerLink]="'/historial/ep'">
          <div class="icono">
            <img class="imagen" src="assets/icons/clientes.png" />
            <img class="animacion" src="assets/icons/clientes.gif" />
          </div>
          <p>Consular Paciente</p>
        </a>
      </div>
    </div>
  }
</div>
